import AlertTriangleIcon from '@assets/icons/alert-triangle.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  compact?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  isError?: boolean;
  testID?: string;
  text: string;
}

export const StatusLabel: React.FC<Props> = ({
  compact = false,
  containerStyle,
  isError = false,
  testID,
  text,
}) => {
  const [styles, theme] = useStyles();
  return (
    <View
      style={[
        styles.base,
        isError ? styles.baseError : styles.baseWarning,
        compact ? styles.circular : null,
        containerStyle,
      ]}
      testID={testID}
    >
      <AlertTriangleIcon
        fill={isError ? theme.sk.color.text.error : theme.sk.color.text.warning}
        height={12}
        width={12}
      />
      {compact ? null : (
        <Text
          numberOfLines={1}
          style={[
            TYPOGRAPHY.xsmall,
            isError ? styles.textError : styles.textWarning,
          ]}
        >
          {text}
        </Text>
      )}
    </View>
  );
};

const CIRCULAR_SIZE = 18;
const useStyles = createStyles((theme) => ({
  base: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.warning,
    borderRadius: 32,
    flexDirection: 'row',
    gap: 4,
    height: 20,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },
  baseError: {
    backgroundColor: theme.sk.color.bg.error,
  },
  baseWarning: {
    backgroundColor: theme.sk.color.bg.warning,
  },
  circular: {
    borderRadius: CIRCULAR_SIZE / 2,
    height: CIRCULAR_SIZE,
    justifyContent: 'center',
    paddingHorizontal: 0,
    paddingVertical: 0,
    width: CIRCULAR_SIZE,
  },
  textError: {
    color: theme.sk.color.text.error,
  },
  textWarning: {
    color: theme.sk.color.text.warning,
  },
}));
